import React from 'react';
import { useAsyncDebounce } from 'react-table';
import { Box, TextField } from '@material-ui/core';
import { useStyles } from './styles';

export default function ApplicationsTableGlobalFilter({
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
}) {
    const classes = useStyles();
    const count = preGlobalFilteredRows.length;
    const [value, setValue] = React.useState(globalFilter);

    const onChange = useAsyncDebounce(value => {
        setGlobalFilter(value || undefined);
    }, 200);

    return (
        <Box className={classes.root}>
            <TextField
                type="search"
                label="Search"
                variant="outlined"
                value={value || ''}
                onChange={e => {
                    setValue(e.target.value);
                    onChange(e.target.value);
                }}
                placeholder={`${count} records...`}
                className={classes.search}
            />
        </Box>
    );
}
